import { useEffect } from 'react'
// import jwtDecode from "jwt-decode";
import { getRefreshedToken } from '../contexts/actionCreators'
import { useInterval } from './useSetInterval'
import { useAuthDispatch } from '../contexts/authContext'

const useTokenRefresh = () => {
  const dispatchAuthAction = useAuthDispatch()

  const storedAuthStateJson =
    sessionStorage.getItem('authState') || localStorage.getItem('authState')
  const storedAuthState = storedAuthStateJson ? JSON.parse(storedAuthStateJson) : null

  const checkToken = async () => {
    const token = storedAuthState?.user?.accessToken || ''
    if (token) {
      // const { exp } = jwtDecode<JWTPayload>(token);

      try {
        await getRefreshedToken(dispatchAuthAction)
      } catch (error) {
        console.error('Failed to refresh token', error)
      }
    }
  }

  useEffect(() => {
    checkToken()
  }, [])
  useInterval(checkToken, 30 * 60 * 1000)
}

export default useTokenRefresh
